export enum IssueSeverity {
    Other = 0,
    Warning = 10,
    Error = 20,
}
